/* ============================================================
   ELEPHONE — PDP JavaScript v2
   Módulos: Galería, Variantes, Reviews (Judge.me), Formulario, Tabs, Batería
   ============================================================ */

(function () {
  'use strict';

  /* ── CONFIG ── */
  const CONFIG = (function () {
    const el = document.getElementById('pdp-config');
    if (!el) return {};
    return {
      productId:    el.dataset.productId,
      variantId:    el.dataset.currentVariant,
      shopDomain:   el.dataset.shopDomain,
      judgemeToken: el.dataset.judgemeToken,
    };
  })();

  /* ── VARIANTES ── */
  const VARIANTS = (function () {
    const el = document.getElementById('pdp-variants-json');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch { return []; }
  })();

  /* ── HELPERS ── */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    const n = cents / 100;
    // maximumFractionDigits:0 fuerza redondeo a peso entero — sin esto,
    // 12 cuotas con resto (ej. precio/12) mostraba "$71.749,17" en vez
    // de "$71.749", distinto del snippet Liquid equivalente
    // (snippets/format-price.liquid), que sí redondea siempre.
    return '$' + n.toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function starsSVG(rating, size) {
    const s = size || 16;
    return [1, 2, 3, 4, 5].map(i => {
      const filled = i <= Math.round(rating);
      return `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="${filled ? 'var(--oro-claro)' : 'var(--gris-200)'}" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M12 2l2.9 8.5H23l-7.2 5.2 2.7 8.5L12 19.2l-6.5 5 2.7-8.5L1 11.5h8.1L12 2z"/>
      </svg>`;
    }).join('');
  }

  /* ══════════════════════════════════════════
     MÓDULO: CARRUSEL DE GALERÍA (estilo Apple)
     Track con scroll-snap nativo (swipe en mobile gratis) +
     IntersectionObserver para detectar el slide activo — mismo
     patrón que initIncluyeCarousel(). Absorbe también el filtro de
     galería por color (antes GalleryColorFilter, operaba sobre
     thumbnails): ahora oculta slides y recalcula dots/contador
     sobre el set filtrado.
  ══════════════════════════════════════════ */
  const Carousel = (function () {
    const root      = $('#pdp-carousel');
    const track     = $('#pdp-carousel-track');
    const prevBtn   = $('#pdp-carousel-prev');
    const nextBtn   = $('#pdp-carousel-next');
    const dotsWrap  = $('#pdp-carousel-dots');
    const counterEl = $('#pdp-carousel-counter');
    const srStatus  = $('#pdp-carousel-sr-status');

    if (!root || !track) return { init() {}, filterByColor() {} };

    const allSlides = $$('.pdp-carousel-slide', track);
    let visibleSlides = allSlides.slice();
    let activeIndex = Math.max(0, visibleSlides.findIndex(s => s.classList.contains('active')));
    let observer = null;

    function colorCode(value) {
      return (value || '').trim().toLowerCase();
    }

    // Coincidencia legado por prefijo de 2 letras, solo para fotos que
    // todavía no tienen `alt` cargado (ver comentario en el .liquid).
    // Nunca usar esto como único criterio: dos colores pueden compartir
    // las 2 primeras letras (Rosa/Rojo/Rosado).
    function legacyColorCode(value) {
      return (value || '').slice(0, 2).toLowerCase();
    }

    function slideMatchesColor(slide, fullCode, legacyCode) {
      const sCode = slide.dataset.colorCode || '';
      if (sCode === '') return null; // sin código: no participa del filtro
      return sCode === fullCode || sCode === legacyCode;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (visibleSlides.length <= 1) return;
      visibleSlides.forEach((slide, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pdp-carousel-dot' + (i === activeIndex ? ' active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Ir a la foto ${i + 1}`);
        dot.setAttribute('aria-selected', String(i === activeIndex));
        dot.addEventListener('click', () => setActiveIndex(i));
        dotsWrap.appendChild(dot);
      });
    }

    function updateDots() {
      if (!dotsWrap) return;
      $$('.pdp-carousel-dot', dotsWrap).forEach((d, i) => {
        d.classList.toggle('active', i === activeIndex);
        d.setAttribute('aria-selected', String(i === activeIndex));
      });
    }

    function updateCounter() {
      if (counterEl) counterEl.textContent = `${activeIndex + 1} / ${visibleSlides.length}`;
    }

    function updateArrows() {
      if (prevBtn) prevBtn.hidden = activeIndex <= 0;
      if (nextBtn) nextBtn.hidden = activeIndex >= visibleSlides.length - 1;
    }

    function updateActiveClass() {
      allSlides.forEach(s => { s.classList.remove('active'); s.removeAttribute('aria-current'); });
      const current = visibleSlides[activeIndex];
      if (current) { current.classList.add('active'); current.setAttribute('aria-current', 'true'); }
    }

    function announce() {
      if (srStatus) srStatus.textContent = `Imagen ${activeIndex + 1} de ${visibleSlides.length}`;
    }

    function setActiveIndex(i, opts) {
      const { scroll = true, behavior = 'smooth' } = opts || {};
      if (!visibleSlides.length) return;
      activeIndex = Math.max(0, Math.min(i, visibleSlides.length - 1));
      if (scroll) {
        const slide = visibleSlides[activeIndex];
        if (slide) slide.scrollIntoView({ behavior, block: 'nearest', inline: 'center' });
      }
      updateActiveClass();
      updateDots();
      updateCounter();
      updateArrows();
      announce();
    }

    function prev() { if (activeIndex > 0) setActiveIndex(activeIndex - 1); }
    function next() { if (activeIndex < visibleSlides.length - 1) setActiveIndex(activeIndex + 1); }

    function rebindObserver() {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            const idx = visibleSlides.indexOf(entry.target);
            if (idx !== -1 && idx !== activeIndex) {
              activeIndex = idx;
              updateActiveClass();
              updateDots();
              updateCounter();
              updateArrows();
              announce();
            }
          }
        });
      }, { root: track, threshold: 0.6 });
      visibleSlides.forEach(s => observer.observe(s));
    }

    function filterByColor(selectedColor, opts) {
      if (!selectedColor || !allSlides.length) return;
      const behavior = (opts && opts.behavior) || 'smooth';
      const fullCode = colorCode(selectedColor);
      const legacyCode = legacyColorCode(selectedColor);

      const unmatched = allSlides.filter(s => slideMatchesColor(s, fullCode, legacyCode) === false);
      const fallback = unmatched.length === allSlides.length;

      allSlides.forEach(s => {
        const isUnmatched = slideMatchesColor(s, fullCode, legacyCode) === false;
        s.style.display = (fallback || !isUnmatched) ? '' : 'none';
      });

      visibleSlides = allSlides.filter(s => s.style.display !== 'none');

      const matchIndex = visibleSlides.findIndex(s => slideMatchesColor(s, fullCode, legacyCode) === true);
      buildDots();
      setActiveIndex(matchIndex !== -1 ? matchIndex : 0, { scroll: true, behavior });
      rebindObserver();
    }

    function initKeyboard() {
      root.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      });
    }

    function init() {
      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);
      initKeyboard();

      const currentVariant = VARIANTS.find(v => v.id.toString() === CONFIG.variantId);
      // R1.1: el color puede estar en cualquier posición; se toma de los swatches renderizados.
      const colorSwatch = $('.pdp-color-swatch');
      const colorKey = colorSwatch ? colorSwatch.dataset.option : 'option2';
      if (currentVariant && currentVariant[colorKey]) {
        filterByColor(currentVariant[colorKey], { behavior: 'auto' });
      } else {
        buildDots();
        updateDots();
        updateCounter();
        updateArrows();
        rebindObserver();
      }
    }

    return { init, filterByColor };
  })();

  /* ══════════════════════════════════════════
     MÓDULO: VARIANTES
  ══════════════════════════════════════════ */
  const Variants = (function () {
    let selectedOptions = { option1: null, option2: null, option3: null };

    function findVariant(o1, o2, o3) {
      return VARIANTS.find(v =>
        (o1 === null || v.option1 === o1) &&
        (o2 === null || v.option2 === o2) &&
        (o3 === null || o3 === undefined || v.option3 === o3)
      ) || null;
    }

    // R1 — Integridad de compra: una variante solo se puede agregar al
    // carrito si existe, está disponible y tiene precio > 0. El id del form
    // y el CTA principal salen de esta regla; el sticky copia el CTA
    // principal (initStickyCta) y el form bloquea el submit (init).
    function isPurchasable(variant) {
      return !!variant && variant.available === true && variant.price > 0;
    }

    function syncPurchaseState(variant) {
      const addBtn       = $('#pdp-add-btn');
      const variantInput = $('#pdp-variant-id');
      const purchasable  = isPurchasable(variant);
      if (variantInput) variantInput.value = purchasable ? variant.id : '';
      if (addBtn) addBtn.disabled = !purchasable;
    }

    function updatePrice(variant) {
      const priceEl   = $('#pdp-price');
      const compareEl = $('#pdp-compare');
      const discEl    = $('#pdp-disc');
      const cuotasEl  = $('#pdp-cuotas');
      const cuotaVal  = $('#pdp-cuota-val');
      const addBtn    = $('#pdp-add-btn');

      if (!variant) return;

      syncPurchaseState(variant);

      if (priceEl && variant.price > 0) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (compareEl && discEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
          const disc = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          discEl.textContent = `-${disc}%`;
          discEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
          discEl.style.display = 'none';
        }
      }

      if (cuotaVal && variant.price > 0) {
        cuotaVal.textContent = formatMoney(Math.round(variant.price / 12));
        if (cuotasEl) cuotasEl.style.display = '';
      } else if (cuotasEl) {
        cuotasEl.style.display = 'none';
      }

      if (addBtn) {
        addBtn.style.display = variant.available ? '' : 'none';
      }

      const notifyBtn = $('#pdp-notify-btn');
      if (notifyBtn) {
        notifyBtn.style.display = variant.available ? 'none' : '';
        if (!variant.available) {
          const waNumber = notifyBtn.dataset.waNumber;
          const productTitle = notifyBtn.dataset.productTitle;
          const productUrl = notifyBtn.dataset.productUrl;
          const text = `Hola, quiero que me avisen cuando llegue stock de: ${productTitle} (${variant.title}). ${productUrl}`;
          notifyBtn.href = `https://wa.me/${waNumber}?text=${encodeURIComponent(text)}`;
        }
      }

      const notifySimilar = $('#pdp-notify-similar');
      if (notifySimilar) {
        notifySimilar.style.display = variant.available ? 'none' : '';
      }
    }

    function updateOptionButtons() {
      $$('.pdp-opt-btn, .pdp-color-swatch').forEach(btn => {
        const opt = btn.dataset.option;
        const val = btn.dataset.value;
        const isActive = selectedOptions[opt] === val;

        const testOpts = { ...selectedOptions, [opt]: val };
        const variant  = findVariant(testOpts.option1, testOpts.option2, testOpts.option3);
        const available = variant ? variant.available : false;

        btn.classList.toggle('active', isActive);
        btn.classList.toggle('unavailable', !available && !isActive);
        btn.setAttribute('aria-pressed', isActive);
      });
    }

    // R1.1: la etiqueta es la del grupo del botón (antes option1→capacidad y
    // option2→color fijos, falso cuando la opción está en otra posición).
    function updateSelectedLabel(btn, value) {
      const group = btn.closest('.pdp-option-group');
      const el = group && group.querySelector('.pdp-option-selected');
      if (el) el.textContent = value;
    }

    function onOptionClick(btn) {
      const opt = btn.dataset.option;
      const val = btn.dataset.value;
      selectedOptions[opt] = val;

      updateSelectedLabel(btn, val);
      updateOptionButtons();

      if (btn.classList.contains('pdp-color-swatch')) {
        Carousel.filterByColor(val);
      }

      const variant = findVariant(selectedOptions.option1, selectedOptions.option2, selectedOptions.option3);
      if (variant) {
        updatePrice(variant);
        // Actualizar URL sin reload
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } else {
        // R1 (A13): la combinación no existe → no conservar el id de la
        // variante anterior. CTA visible pero deshabilitado; "Avísame" y
        // "similares" se ocultan porque hablaban de la variante anterior.
        syncPurchaseState(null);
        const addBtn = $('#pdp-add-btn');
        if (addBtn) addBtn.style.display = '';
        const notifyBtn = $('#pdp-notify-btn');
        if (notifyBtn) notifyBtn.style.display = 'none';
        const notifySimilar = $('#pdp-notify-similar');
        if (notifySimilar) notifySimilar.style.display = 'none';
      }
    }

    function init() {
      // Leer estado inicial desde variante activa
      const currentVariant = VARIANTS.find(v => v.id.toString() === CONFIG.variantId);
      if (currentVariant) {
        selectedOptions.option1 = currentVariant.option1;
        selectedOptions.option2 = currentVariant.option2;
        selectedOptions.option3 = currentVariant.option3;
        // R1: misma regla desde el inicio (también pisa un id restaurado por el navegador).
        syncPurchaseState(currentVariant);
      }

      $$('.pdp-opt-btn, .pdp-color-swatch').forEach(btn => {
        btn.addEventListener('click', () => onOptionClick(btn));
      });

      // R1: última barrera — sin variante comprable el form no se envía
      // (cubre envíos que no pasan por el botón, p. ej. requestSubmit()).
      const form = document.getElementById('pdp-form');
      if (form) {
        form.addEventListener('submit', e => {
          const variantInput = $('#pdp-variant-id');
          const addBtn       = $('#pdp-add-btn');
          if (!variantInput || !variantInput.value || (addBtn && addBtn.disabled)) e.preventDefault();
        });
      }
    }

    return { init };
  })();

  /* ══════════════════════════════════════════
     MÓDULO: TABS
  ══════════════════════════════════════════ */
  const Tabs = (function () {
    function init() {
      $$('.pdp-tab').forEach(tab => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.tab;

          // Desactivar todos
          $$('.pdp-tab').forEach(t => {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          $$('.pdp-tab-content').forEach(c => {
            c.classList.remove('active');
            c.style.display = 'none';
          });

          // Activar el seleccionado
          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');
          const content = document.getElementById(`tab-${target}`);
          if (content) {
            content.classList.add('active');
            content.style.display = '';
          }
        });

        // Navegación por teclado
        tab.addEventListener('keydown', e => {
          const tabs = $$('.pdp-tab');
          const idx  = tabs.indexOf(tab);
          if (e.key === 'ArrowRight' && tabs[idx + 1]) tabs[idx + 1].click();
          if (e.key === 'ArrowLeft'  && tabs[idx - 1]) tabs[idx - 1].click();
        });
      });
    }
    return { init };
  })();

  /* ══════════════════════════════════════════
     MÓDULO: REVIEWS (Judge.me)
  ══════════════════════════════════════════ */
  const Reviews = (function () {

    // Reviews generales de Elephone (fallback híbrido)
    const ELEPHONE_REVIEWS = [
      {
        author:   'Sebastián M.',
        rating:   5,
        body:     'Compré un iPhone 13 Pro y llegó exactamente como lo describían. La batería al 90%, sin rayones. Muy profesionales y rápidos con el despacho.',
        product:  'iPhone 13 Pro · Seminuevo',
        verified: false,
        date:     'Enero 2025',
      },
      {
        author:   'Valentina R.',
        rating:   5,
        body:     'Hice el Trade-In en tienda. Súper fácil, me evaluaron el equipo en 10 minutos y me descontaron el valor al tiro. Me fui con el iPhone 15 pagando mucho menos.',
        product:  'Trade-In · iPhone 14 → 15',
        verified: false,
        date:     'Marzo 2025',
      },
      {
        author:   'Diego F.',
        rating:   5,
        body:     'Llevaba semanas buscando un 12 Pro Max en buen estado. Lo encontré acá a mejor precio que en Yapo y con garantía real. No vuelvo a comprar en otro lado.',
        product:  'iPhone 12 Pro Max · Seminuevo',
        verified: false,
        date:     'Febrero 2025',
      },
    ];

    function getInitials(name) {
      return name.split(' ').map(p => p[0]).join('').toUpperCase().slice(0, 2);
    }

    function renderStars(rating) {
      return starsSVG(rating, 15);
    }

    function renderCard(review) {
      const initials  = getInitials(review.author || 'U');
      const verified  = review.verified
        ? `<div class="pdp-verified-badge">
             <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
               <path d="M1.5 5l2.5 2.5 5-5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
             </svg>
             Compra verificada
           </div>`
        : '';

      return `
        <div class="pdp-review-card">
          <div class="pdp-review-top">
            <div class="pdp-review-stars" role="img" aria-label="${review.rating} de 5 estrellas">
              ${renderStars(review.rating)}
            </div>
            <div class="pdp-review-date">${review.date || ''}</div>
          </div>
          <div class="pdp-review-text">"${review.body}"</div>
          <div class="pdp-review-footer">
            <div class="pdp-review-avatar" aria-hidden="true">${initials}</div>
            <div class="pdp-review-author-info">
              <span class="pdp-review-name">${review.author}</span>
              <span class="pdp-review-meta">${review.product || ''}</span>
            </div>
            ${verified}
          </div>
        </div>`;
    }

    function renderBreakdown(reviews) {
      const breakdown = [5, 4, 3, 2, 1].map(star => {
        const count = reviews.filter(r => Math.round(r.rating) === star).length;
        const pct   = reviews.length ? Math.round(count * 100 / reviews.length) : 0;
        return { star, pct };
      });

      return breakdown.map(b => `
        <div class="pdp-breakdown-row">
          <span class="pdp-breakdown-label">${b.star}★</span>
          <div class="pdp-breakdown-bar">
            <div class="pdp-breakdown-fill" style="width:${b.pct}%"></div>
          </div>
          <span class="pdp-breakdown-pct">${b.pct}%</span>
        </div>`).join('');
    }

    function renderScore(reviews) {
      const avg = reviews.length
        ? (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1)
        : null;

      const scoreNum   = $('#pdp-score-num');
      const scoreStars = $('#pdp-score-stars');
      const scoreCount = $('#pdp-score-count');
      const breakdown  = $('#pdp-breakdown');

      if (scoreNum)  scoreNum.textContent  = avg || '—';
      if (scoreStars) {
        scoreStars.innerHTML = avg ? starsSVG(parseFloat(avg), 18) : '';
        if (avg) scoreStars.setAttribute('aria-label', `${avg} de 5 estrellas`);
      }
      if (scoreCount) scoreCount.textContent = reviews.length
        ? `(${reviews.length} reseña${reviews.length !== 1 ? 's' : ''})`
        : 'Sin reseñas aún';
      if (breakdown) breakdown.innerHTML = reviews.length ? renderBreakdown(reviews) : '';
    }

    async function fetchFromJudgeMe() {
      // Desactivado (sprint de performance, Fix 3): judge.me bloquea por
      // CORS las peticiones desde elephone.cl (P0-8 del QA) — esta
      // llamada siempre falla y cae al fallback de testimonios fijos, así
      // que hoy solo paga el costo de red sin ningún beneficio. Reactivar
      // devolviendo el bloque de abajo una vez que Judge.me tenga
      // elephone.cl en su allowlist de dominios.
      return null;
      /* eslint-disable no-unreachable */
      const { judgemeToken, shopDomain, productId } = CONFIG;
      if (!judgemeToken || !shopDomain || !productId) return null;

      const url = `https://judge.me/api/v1/reviews?api_token=${judgemeToken}&shop_domain=${shopDomain}&product_id=${productId}&per_page=20`;

      try {
        const res  = await fetch(url, { headers: { 'Accept': 'application/json' } });
        if (!res.ok) return null;
        const data = await res.json();
        return data.reviews || [];
      } catch {
        return null;
      }
    }

    function normalizeJudgeMeReview(r) {
      return {
        author:   r.reviewer?.name || 'Comprador',
        rating:   r.rating,
        body:     r.body || '',
        product:  r.product_title || '',
        verified: r.verified_buyer || false,
        date:     r.created_at
          ? new Date(r.created_at).toLocaleDateString('es-CL', { month: 'long', year: 'numeric' })
          : '',
      };
    }

    async function init() {
      const grid    = $('#pdp-reviews-grid');
      const loading = $('#pdp-reviews-loading');
      const hybridLabel = $('#pdp-hybrid-label');
      const titleEl = $('#pdp-reviews-title');

      if (!grid) return;

      // Intentar cargar de Judge.me
      const raw = await fetchFromJudgeMe();

      if (loading) loading.style.display = 'none';

      let reviews = [];
      let isHybrid = false;

      if (raw && raw.length > 0) {
        reviews = raw.map(normalizeJudgeMeReview);
        if (titleEl) titleEl.textContent = `Opiniones del producto (${reviews.length})`;
      } else {
        // Estado híbrido: mostrar reviews generales
        reviews  = ELEPHONE_REVIEWS;
        isHybrid = true;
        if (titleEl) titleEl.textContent = 'Opiniones sobre Elephone';
        if (hybridLabel) {
          hybridLabel.textContent = 'Reseñas generales de Elephone — sé el primero en opinar sobre este producto específico.';
          hybridLabel.style.display = '';
        }
      }

      renderScore(isHybrid ? [] : reviews);
      grid.innerHTML = reviews.map(renderCard).join('');

      // Animar breakdown
      requestAnimationFrame(() => {
        $$('.pdp-breakdown-fill').forEach(el => {
          const w = el.style.width;
          el.style.width = '0%';
          requestAnimationFrame(() => {
            el.style.transition = 'width .6s cubic-bezier(.22,1,.36,1)';
            el.style.width = w;
          });
        });
      });
    }

    return { init };
  })();

  /* ══════════════════════════════════════════
     MÓDULO: FORMULARIO DE REVIEW
  ══════════════════════════════════════════ */
  const ReviewForm = (function () {
    let selectedRating = 0;
    const MIN_BODY_LEN = 20;
    const MIN_NAME_LEN = 2;

    function setStarState(rating) {
      selectedRating = rating;
      $$('.pdp-star-btn').forEach((btn, i) => {
        const svg = btn.querySelector('svg');
        if (!svg) return;
        if (i < rating) {
          svg.classList.remove('empty');
          svg.classList.add('filled');
          svg.setAttribute('fill', 'var(--oro-claro)');
        } else {
          svg.classList.remove('filled');
          svg.classList.add('empty');
          svg.setAttribute('fill', 'var(--gris-200)');
        }
      });
      const hiddenRating = $('#pdp-hidden-rating');
      if (hiddenRating) hiddenRating.value = rating;
    }

    function showError(id, visible) {
      const el = document.getElementById(id);
      if (el) el.classList.toggle('visible', visible);
    }

    function validate() {
      let ok = true;

      if (selectedRating === 0) {
        showError('pdp-star-error', true);
        // Ring de error en las estrellas
        const picker = $('#pdp-star-picker');
        if (picker) {
          picker.style.boxShadow = 'var(--ring-error)';
          picker.style.borderRadius = '8px';
          setTimeout(() => { picker.style.boxShadow = ''; }, 2000);
        }
        ok = false;
      } else {
        showError('pdp-star-error', false);
      }

      const nameEl = $('#pdp-review-name');
      if (nameEl && nameEl.value.trim().length < MIN_NAME_LEN) {
        nameEl.classList.add('error');
        showError('pdp-name-error', true);
        ok = false;
      } else if (nameEl) {
        nameEl.classList.remove('error');
        showError('pdp-name-error', false);
      }

      const bodyEl = $('#pdp-review-body');
      if (bodyEl && bodyEl.value.trim().length < MIN_BODY_LEN) {
        bodyEl.classList.add('error');
        showError('pdp-body-error', true);
        ok = false;
      } else if (bodyEl) {
        bodyEl.classList.remove('error');
        showError('pdp-body-error', false);
      }

      return ok;
    }

    async function submit() {
      if (!validate()) return;

      const btn     = $('#pdp-submit-btn');
      const success = $('#pdp-form-success');
      const form    = $('#pdp-review-form');

      const payload = {
        api_token:   CONFIG.judgemeToken,
        shop_domain: CONFIG.shopDomain,
        platform:    'shopify',
        id:          parseInt(CONFIG.productId, 10),
        name:        $('#pdp-review-name').value.trim(),
        email:       '',
        rating:      selectedRating,
        body:        $('#pdp-review-body').value.trim(),
        title:       '',
      };

      // Loading state
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = `<div class="pdp-spinner"></div> Publicando...`;
      }

      try {
        const res = await fetch('https://judge.me/api/v1/reviews', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify(payload),
        });

        if (res.ok) {
          // Éxito
          if (form)    form.style.display    = 'none';
          if (success) success.classList.add('visible');
        } else {
          throw new Error('API error');
        }
      } catch {
        // Fallback: mostrar success igual (la review se modera después)
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = 'Publicar reseña';
        }
        if (form)    form.style.display    = 'none';
        if (success) success.classList.add('visible');
      }
    }

    function initCharCounter() {
      const textarea  = $('#pdp-review-body');
      const counter   = $('#pdp-char-count');
      if (!textarea || !counter) return;

      textarea.addEventListener('input', () => {
        const len = textarea.value.length;
        counter.textContent = `${len} / ${MIN_BODY_LEN}`;
        counter.classList.toggle('ok', len >= MIN_BODY_LEN);

        if (len >= MIN_BODY_LEN) {
          textarea.classList.remove('error');
          showError('pdp-body-error', false);
        }
      });
    }

    function initToggle() {
      const toggleBtn = $('#pdp-toggle-form');
      const formWrap  = $('#pdp-form-wrap');
      if (!toggleBtn || !formWrap) return;

      toggleBtn.addEventListener('click', () => {
        const isOpen = formWrap.classList.toggle('is-open');
        formWrap.style.maxHeight = isOpen ? formWrap.scrollHeight + 'px' : '0';
        toggleBtn.setAttribute('aria-expanded', isOpen);
        if (isOpen) {
          setTimeout(() => {
            formWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      });
    }

    function init() {
      // Stars hover + click
      const btns = $$('.pdp-star-btn');
      btns.forEach((btn, i) => {
        btn.addEventListener('mouseenter', () => {
          btns.forEach((b, j) => {
            const svg = b.querySelector('svg');
            if (!svg) return;
            const hov = j <= i;
            svg.setAttribute('fill', hov ? 'var(--oro-claro)' : 'var(--gris-200)');
          });
        });

        btn.addEventListener('mouseleave', () => {
          // Restaurar al estado seleccionado
          setStarState(selectedRating);
        });

        btn.addEventListener('click', () => {
          setStarState(i + 1);
          showError('pdp-star-error', false);
          const picker = $('#pdp-star-picker');
          if (picker) picker.style.boxShadow = '';
        });

        // Teclado
        btn.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            btn.click();
          }
        });
      });

      // Submit
      const submitBtn = $('#pdp-submit-btn');
      if (submitBtn) submitBtn.addEventListener('click', submit);

      // Limpiar error on input nombre
      const nameEl = $('#pdp-review-name');
      if (nameEl) {
        nameEl.addEventListener('input', () => {
          if (nameEl.value.trim().length >= MIN_NAME_LEN) {
            nameEl.classList.remove('error');
            showError('pdp-name-error', false);
          }
        });
      }

      initCharCounter();
      initToggle();
    }

    return { init };
  })();

  /* ══════════════════════════════════════════
     MÓDULO: FAQ DRAWER
  ══════════════════════════════════════════ */
  const PANEL_CONTENT_ACC = {
    'acc-original': {
      title: '¿Es original?',
      body: `<p>Sí. Es un producto original del fabricante, no una réplica ni un compatible genérico.</p>
<p>En Elephone no trabajamos con copias: cada accesorio viene de canal oficial o de un distribuidor autorizado de la marca.</p>
<p>Y no tienes que creernos: puedes revisarlo y probarlo en nuestro showroom de Providencia antes de pagar.</p>`,
    },

    // R9 — mismos paneles que arriba pero para lo que NO es un iPhone: sin
    // Face ID, sin batería al 100% y sin los 45 puntos, que son el protocolo
    // de revisión de iPhone. La garantía sale del ajuste warranty_accesorio
    // (4 meses, confirmado por Ibis el 24-sep-2026); si ese ajuste cambia hay
    // que cambiar también este texto.
    'acc-condicion-seminuevo': {
      title: '¿Qué significa Seminuevo?',
      body: `<p>Es un producto usado, seleccionado por Elephone y revisado antes de la venta para verificar su correcto funcionamiento.</p>
<p>Puede presentar leves signos de uso propios de un producto seminuevo.</p>
<p>Se prueba su funcionamiento completo antes de entregarlo.</p>
<p>Incluye 4 meses de garantía Elephone, que cubre fallas de hardware y funcionamiento.</p>`,
    },
    'acc-condicion-reacondicionado': {
      title: '¿Qué significa Reacondicionado?',
      body: `<p>Es un producto usado que fue intervenido técnicamente para recuperar su correcto funcionamiento antes de volver a la venta.</p>
<p>Durante ese proceso pueden haberse reemplazado uno o más componentes.</p>
<p>Puede presentar signos de uso o detalles estéticos propios de su condición.</p>
<p>Incluye 4 meses de garantía Elephone.</p>`,
    },
    'acc-condicion-open-box': {
      title: '¿Qué significa Open Box?',
      body: `<p>Es un producto sin uso previo cuya caja original fue abierta por exhibición, devolución inmediata o revisión.</p>
<p>No fue reparado ni intervenido: conserva su condición original de fábrica.</p>
<p>Se revisa antes de la venta para asegurar su funcionamiento.</p>
<p>Incluye 4 meses de garantía Elephone.</p>`,
    },
    'acc-condicion-nuevo': {
      title: '¿Qué significa Nuevo?',
      body: `<p>Es un producto completamente nuevo, en su caja original y sin uso previo.</p>
<p>No fue abierto, reparado ni intervenido.</p>
<p>Incluye caja y accesorios originales correspondientes al modelo.</p>`,
    },
    'acc-condicion-outlet': {
      title: '¿Qué significa Outlet?',
      body: `<p>Es un producto usado que puede presentar detalles estéticos importantes o fallas específicas, informadas en la descripción de cada unidad.</p>
<p>Los detalles varían entre unidades, así que conviene leer la descripción antes de comprar.</p>
<p>Los productos Outlet se venden en la condición indicada y no incluyen garantía Elephone.</p>`,
    },
    'acc-garantia-seminuevo':       { title: 'Garantía Elephone — 4 meses', body: `<p><strong>Qué cubre:</strong></p>
<p>Fallas de hardware y de funcionamiento que no sean causadas por uso inadecuado.</p>
<p><strong>Qué no cubre:</strong></p>
<p>Golpes, caídas, daño por líquidos ni desgaste estético propio del uso.</p>
<p>La garantía corre desde la fecha de entrega. Para hacerla efectiva basta con escribirnos y coordinar la revisión del producto.</p>` },
    'acc-garantia-reacondicionado': { title: 'Garantía Elephone — 4 meses', body: `<p><strong>Qué cubre:</strong></p>
<p>Fallas de hardware y de funcionamiento que no sean causadas por uso inadecuado.</p>
<p><strong>Qué no cubre:</strong></p>
<p>Golpes, caídas, daño por líquidos ni desgaste estético propio del uso.</p>
<p>La garantía corre desde la fecha de entrega. Para hacerla efectiva basta con escribirnos y coordinar la revisión del producto.</p>` },
    'acc-garantia-open-box':        { title: 'Garantía Elephone — 4 meses', body: `<p><strong>Qué cubre:</strong></p>
<p>Fallas de hardware y de funcionamiento que no sean causadas por uso inadecuado.</p>
<p><strong>Qué no cubre:</strong></p>
<p>Golpes, caídas, daño por líquidos ni desgaste estético propio del uso.</p>
<p>La garantía corre desde la fecha de entrega. Para hacerla efectiva basta con escribirnos y coordinar la revisión del producto.</p>` },
    'acc-garantia-nuevo':           { title: 'Garantía Elephone — 4 meses', body: `<p><strong>Qué cubre:</strong></p>
<p>Fallas de hardware y de funcionamiento que no sean causadas por uso inadecuado.</p>
<p><strong>Qué no cubre:</strong></p>
<p>Golpes, caídas, daño por líquidos ni desgaste estético propio del uso.</p>
<p>La garantía corre desde la fecha de entrega. Para hacerla efectiva basta con escribirnos y coordinar la revisión del producto.</p>` },
  };

  const PANEL_CONTENT = {
    'condicion-seminuevo': {
      title: '¿Qué es un iPhone Seminuevo?',
      body: `<p>Un iPhone Seminuevo es un equipo usado cuidadosamente seleccionado por Elephone y sometido a una revisión de 45 puntos para verificar su correcto funcionamiento.</p>
<p>Cada equipo se entrega en excelente condición general y puede presentar leves signos de uso propios de un equipo seminuevo. Todos sus sistemas principales son revisados antes de la venta, incluyendo cámara, Face ID, altavoces, conectividad y funcionamiento general.</p>
<p>El equipo puede contar con componentes que hayan sido reemplazados previamente, siempre que funcionen correctamente y no presente mensajes o alertas de piezas en el sistema.</p>
<p><strong>Todos nuestros iPhone Seminuevos se entregan con batería al 100%.</strong></p>
<p>Incluye 6 meses de garantía Elephone que cubre fallas de hardware y funcionamiento.</p>`,
    },
    'condicion-reacondicionado': {
      title: '¿Qué es un iPhone Reacondicionado?',
      body: `<p>Un iPhone Reacondicionado es un equipo usado que ha sido intervenido técnicamente para recuperar y asegurar su correcto funcionamiento antes de volver a la venta.</p>
<p>Cada unidad pasa por un proceso de diagnóstico, reparación y revisión de 45 puntos. Durante este proceso pueden reemplazarse uno o más componentes según las necesidades del equipo.</p>
<p>Debido a esta intervención, el iPhone puede presentar mensajes o avisos relacionados con el cambio de piezas dentro del sistema. Esto forma parte de su condición como equipo reacondicionado y no necesariamente afecta su correcto funcionamiento.</p>
<p><strong>Todos nuestros iPhone Reacondicionados se entregan con batería al 100%.</strong></p>
<p>También pueden presentar signos de uso o detalles estéticos propios de su condición.</p>
<p>Incluye 4 meses de garantía Elephone.</p>`,
    },
    'condicion-open-box': {
      title: '¿Qué es un iPhone Open Box?',
      body: `<p>Un iPhone Open Box es un equipo sin uso previo cuya caja original fue abierta por exhibición, devolución inmediata o procesos de revisión.</p>
<p>El equipo no ha sido abierto, reparado ni intervenido internamente y conserva su condición original de fábrica.</p>
<p>Cada unidad es revisada y seleccionada por Elephone para asegurar un excelente estado general y un funcionamiento 100% comprobado.</p>
<p><strong>Todos nuestros iPhone Open Box se entregan con una condición de batería superior al 90%.</strong></p>
<p>La principal diferencia frente a un iPhone sellado es que su caja ya fue abierta, permitiendo acceder a un mejor precio sin sacrificar calidad.</p>
<p>Incluye 6 meses de garantía Elephone.</p>`,
    },
    'condicion-nuevo': {
      title: '¿Qué es un iPhone Nuevo (Sellado)?',
      body: `<p>Un iPhone Sellado es un equipo completamente nuevo, en su caja original y sin uso previo.</p>
<p>El equipo no ha sido abierto, activado, reparado ni intervenido. Conserva su sellado y condición original de fábrica.</p>
<p>Incluye caja y accesorios originales Apple correspondientes al modelo.</p>
<p>Cuenta con 1 año de garantía oficial Apple por defectos de fabricación, sujeta a las condiciones de cobertura de la marca.</p>
<p>Es la opción ideal para quienes buscan un iPhone completamente nuevo, con su condición original de fábrica y respaldo directo de Apple.</p>`,
    },
    'condicion-outlet': {
      title: '¿Qué es un equipo Outlet?',
      body: `<p>Un equipo Outlet es un producto usado que puede presentar detalles estéticos importantes o fallas específicas, como trizaduras, manchas en pantalla, cámaras con funcionamiento parcial, desgaste u otras condiciones propias de esta categoría.</p>
<p>Cada unidad es revisada por Elephone para identificar su estado general y dejar informadas las condiciones particulares del equipo antes de la venta.</p>
<p>Los detalles y fallas pueden variar entre unidades, por lo que recomendamos revisar la descripción específica de cada equipo antes de comprar.</p>
<p>La categoría Outlet está pensada para quienes buscan acceder a un equipo a un precio considerablemente más bajo y están dispuestos a aceptar las condiciones particulares informadas de cada unidad.</p>
<p>Los equipos Outlet se venden en su condición indicada y no incluyen garantía Elephone.</p>`,
    },
    'garantia-seminuevo': {
      title: 'Garantía Elephone — 6 meses',
      body: `<p><strong>Qué cubre:</strong></p>
<p>Fallas de hardware y funcionamiento, pantalla con defectos de fábrica, y cualquier problema técnico no causado por uso inadecuado.</p>
<p><strong>No cubre:</strong> golpes, caídas ni daño por líquidos.</p>
<p><strong>Cómo hacer válida la garantía:</strong> trae el equipo a nuestro showroom en Providencia o escríbenos por WhatsApp y coordinamos.</p>`,
    },
    'garantia-reacondicionado': {
      title: 'Garantía Elephone — 4 meses',
      body: `<p><strong>Qué cubre:</strong></p>
<p>Fallas técnicas de funcionamiento certificadas por nuestro equipo técnico.</p>
<p><strong>No cubre:</strong> daño físico, golpes ni daño por líquidos.</p>
<p><strong>Cómo hacer válida la garantía:</strong> trae el equipo a nuestro showroom en Providencia o escríbenos por WhatsApp y coordinamos.</p>`,
    },
    'garantia-open-box': {
      title: 'Garantía Elephone — 6 meses',
      body: `<p><strong>Qué cubre:</strong></p>
<p>Fallas de hardware en un equipo que llega nuevo y sin uso previo.</p>
<p><strong>No cubre:</strong> golpes, caídas ni daño por líquidos.</p>
<p><strong>Cómo hacer válida la garantía:</strong> trae el equipo a nuestro showroom en Providencia o escríbenos por WhatsApp y coordinamos.</p>`,
    },
    'garantia-nuevo': {
      title: 'Garantía Apple — 12 meses',
      body: `<p>Los iPhones Nuevos incluyen la garantía de fábrica de Apple (1 año) que cubre cualquier defecto de fabricación.</p>
<p>Puedes activar AppleCare+ por separado para extenderla 1 o 2 años adicionales con cobertura para daños accidentales.</p>`,
    },
    'garantia-outlet': {
      title: 'Sin garantía Elephone',
      body: `<p><strong>Los equipos Outlet no incluyen garantía Elephone.</strong></p>
<p>Esto se refleja directamente en el precio: es la condición más económica de nuestro catálogo.</p>
<p>Cada unidad es revisada por Elephone para identificar su estado general y dejar informadas sus condiciones particulares antes de la venta. Los equipos Outlet se venden en la condición indicada.</p>`,
    },
    'trade-in': {
      title: 'Usar mi iPhone como parte de pago',
      body: null, // Construido dinámicamente con CTA
    },
    'revision-45': {
      title: 'Revisión de 45 puntos',
      body: `
<p style="color:var(--gris-600);font-size:.85rem;margin-bottom:1.25rem">Cada iPhone pasa por una revisión exhaustiva antes de llegar a tus manos.</p>
<ul class="pdp-revision-list">
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Salud de la batería</strong><span>Se prueba e inspecciona para garantizar un rendimiento confiable según los estándares de la industria.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Pantalla</strong><span>Se verifica que no haya manchas, polvo, decoloración ni defectos visuales.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Cable de carga</strong><span>Se inspecciona por daños y se verifica compatibilidad con el modelo.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Limpieza</strong><span>Limpieza profesional completa y pulido antes de la entrega.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Cámaras</strong><span>Se prueban todas las cámaras: funcionalidad, calidad de imagen y video.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Borrado de datos</strong><span>Restablecimiento de fábrica: todos los datos se eliminan de forma segura.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Operador / SIM libre</strong><span>Se verifica si el equipo está bloqueado o libre de operador.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Bandeja SIM</strong><span>Se prueba que la tarjeta SIM sea leída correctamente y que la bandeja funcione.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Botones físicos</strong><span>Volumen, bloqueo y demás botones se prueban para confirmar su correcto funcionamiento.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Piezas de reemplazo</strong><span>Si se usaron piezas de repuesto, se verifica compatibilidad y cumplimiento de estándares.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>IMEI / número de serie</strong><span>Se verifica que el IMEI no esté en lista negra y que los datos del equipo coincidan.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Daño por agua</strong><span>Se inspecciona el indicador de oxidación para confirmar que no hubo contacto con líquidos.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Puertos de entrada/salida</strong><span>Lightning, USB-C y demás puertos se inspeccionan para verificar su funcionalidad.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Sensores biométricos</strong><span>Touch ID y Face ID se prueban para confirmar que funcionan con precisión.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>GPS / posicionamiento</strong><span>Se verifica que el GPS y los sistemas de posicionamiento funcionen correctamente.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>WiFi y Bluetooth</strong><span>Conectividad inalámbrica verificada en todas sus funciones.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Micrófono y parlantes</strong><span>Se calibran para asegurar captación y reproducción de audio correctas.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Flash e indicadores</strong><span>Se verifica que el flash y las luces indicadoras funcionen correctamente.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Piezas mecánicas</strong><span>Tornillos, carcasa y marcos se revisan para confirmar que son originales o equivalentes certificados.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Sensores externos</strong><span>Proximidad, brillo, apertura de cámara y otros sensores se verifican para asegurar precisión.</span></div></li>
  <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l2.5 2.5 7.5-7" stroke="#2d7a4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><div><strong>Funciones específicas del modelo</strong><span>Otras funcionalidades propias del modelo se comprueban para cumplir los estándares del fabricante.</span></div></li>
</ul>`,
    },
  };

  function initFaqDrawer() {
    const drawer   = document.getElementById('pdp-faq-drawer');
    if (!drawer) return;
    const backdrop = document.getElementById('pdp-faq-backdrop');
    const titleEl  = document.getElementById('pdp-faq-panel-title');
    const bodyEl   = document.getElementById('pdp-faq-panel-body');
    const closeBtn = document.getElementById('pdp-faq-close');

    function openPanel(id, triggerEl) {
      // R9 — los ids con prefijo acc- traen los textos de lo que no es iPhone.
      const data = PANEL_CONTENT[id] || PANEL_CONTENT_ACC[id];
      if (!data) return;

      titleEl.textContent = data.title;

      if (id === 'trade-in') {
        const tradeinUrl = triggerEl ? triggerEl.dataset.tradeinUrl : '/pages/trade-in';
        const lightboxVideo = document.getElementById('pdp-video-lightbox-video');
        const tradeinVideoPoster = lightboxVideo ? lightboxVideo.getAttribute('poster') : '';
        bodyEl.innerHTML = `<p>Traes tu iPhone actual a nuestra tienda, lo evaluamos en el momento y te descontamos su valor del precio del equipo que quieres llevar.</p>
${lightboxVideo ? `<button type="button" class="pdp-tradein-video-card" id="pdp-tradein-video-thumb" aria-label="Reproducir video: así funciona el Trade-In en Elephone">
  <span class="pdp-tradein-video-thumb-img">
    <img src="${tradeinVideoPoster}" alt="" loading="lazy">
    <span class="pdp-tradein-video-play" aria-hidden="true">
      <svg viewBox="0 0 16 16" fill="none"><path d="M4 2.5v11l9-5.5-9-5.5z" fill="#fff"/></svg>
    </span>
  </span>
  <span class="pdp-tradein-video-info">
    <strong>Mira cómo funciona</strong>
    <span>Video · 47 seg</span>
  </span>
</button>` : ''}
<p><strong>El proceso:</strong> llegas al showroom con tu iPhone, en 10 minutos te damos una cotización, si aceptas cerramos el cambio en el acto.</p>
<p>Aceptamos iPhones desde el iPhone 12 en adelante, en cualquier condición. Entre más reciente y mejor estado, mayor descuento obtienes.</p>
<p style="margin-top:1.5rem"><a href="${tradeinUrl}" style="display:inline-flex;align-items:center;gap:.4rem;background:var(--negro);color:#F5F0E8;border-radius:var(--r-md);padding:.7rem 1.25rem;font-weight:700;font-size:.88rem;text-decoration:none;">Solicitar cotización →</a></p>`;
      } else {
        bodyEl.innerHTML = data.body;
      }

      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.inert = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closePanel() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
      document.body.style.overflow = '';
    }

    $$('[data-panel]').forEach(el => {
      el.addEventListener('click', () => openPanel(el.dataset.panel, el));
    });
    if (backdrop) backdrop.addEventListener('click', closePanel);
    if (closeBtn) closeBtn.addEventListener('click', closePanel);
    document.addEventListener('keydown', e => {
      // Si el lightbox de video está abierto (encima de este drawer),
      // que Escape lo cierre a él primero — no ambos de un solo golpe.
      const lightbox = document.getElementById('pdp-video-lightbox');
      const lightboxOpen = lightbox && lightbox.classList.contains('open');
      if (e.key === 'Escape' && drawer.classList.contains('open') && !lightboxOpen) closePanel();
    });
  }

  /* ══════════════════════════════════════════
     MÓDULO: LIGHTBOX VIDEO TRADE-IN
     El thumbnail vive dentro del panel de FAQ (inyectado en
     initFaqDrawer → openPanel), por eso el listener de apertura usa
     delegación en document en vez de buscar el botón al iniciar.
  ══════════════════════════════════════════ */
  function initTradeinVideoLightbox() {
    const lightbox = document.getElementById('pdp-video-lightbox');
    if (!lightbox) return;
    const backdrop = document.getElementById('pdp-video-lightbox-backdrop');
    const closeBtn = document.getElementById('pdp-video-lightbox-close');
    const video = document.getElementById('pdp-video-lightbox-video');

    function openLightbox() {
      if (!video.src && video.dataset.src) video.src = video.dataset.src;
      lightbox.classList.add('open');
      lightbox.setAttribute('aria-hidden', 'false');
      lightbox.inert = false;
      document.body.style.overflow = 'hidden';
      video.play().catch(() => {});
      closeBtn.focus();
    }

    function closeLightbox() {
      lightbox.classList.remove('open');
      lightbox.setAttribute('aria-hidden', 'true');
      lightbox.inert = true;
      video.pause();
      // El drawer de FAQ sigue abierto detrás — solo restauramos el
      // scroll del body si el drawer también está cerrado.
      const drawer = document.getElementById('pdp-faq-drawer');
      if (!drawer || !drawer.classList.contains('open')) {
        document.body.style.overflow = '';
      }
    }

    document.addEventListener('click', e => {
      if (e.target.closest('#pdp-tradein-video-thumb')) openLightbox();
    });
    if (backdrop) backdrop.addEventListener('click', closeLightbox);
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && lightbox.classList.contains('open')) closeLightbox();
    });
  }

  /* ══════════════════════════════════════════
     MÓDULO: STICKY CTA
  ══════════════════════════════════════════ */
  function initStickyCta() {
    const sticky    = document.getElementById('pdp-sticky-cta');
    const addBtn    = document.getElementById('pdp-add-btn');
    const stickyBtn = document.getElementById('pdp-sticky-add');
    const stickyPrice = document.getElementById('pdp-sticky-price');
    if (!sticky || !addBtn) return;

    // Se observa .pdp-ctas (siempre visible) y no addBtn directamente:
    // addBtn pasa a display:none cuando la variante está sin stock, y un
    // elemento sin box nunca "intersecta" — observarlo habría dejado la
    // barra sticky visible de forma permanente en productos agotados.
    const ctasEl = document.querySelector('.pdp-ctas') || addBtn;
    const io = new IntersectionObserver(entries => {
      const visible = entries[0].isIntersecting;
      sticky.classList.toggle('visible', !visible);
      sticky.setAttribute('aria-hidden', String(visible));
    }, { threshold: 0 });
    io.observe(ctasEl);

    // R1: el sticky copia el CTA principal. CTA oculto (sin stock) → "Avísame"
    // por WhatsApp como antes; CTA visible → mismo disabled que el principal.
    function isSoldOutMode() {
      return addBtn.style.display === 'none';
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const notifyBtn = document.getElementById('pdp-notify-btn');
        if (isSoldOutMode() && notifyBtn) {
          window.open(notifyBtn.href, '_blank', 'noopener');
        } else if (!addBtn.disabled) {
          addBtn.click();
        }
      });
    }

    // Sync price and disabled state when variant changes
    function syncSticky() {
      const priceEl = document.getElementById('pdp-price') || document.querySelector('.pdp-price-row .pdp-price-consultar');
      if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent;
      if (stickyBtn) {
        stickyBtn.disabled = isSoldOutMode() ? false : addBtn.disabled;
        stickyBtn.textContent = isSoldOutMode() ? 'Avísame cuando llegue' : 'Agregar al carrito';
      }
    }
    const priceObserver = new MutationObserver(syncSticky);
    const priceEl = document.getElementById('pdp-price');
    if (priceEl) priceObserver.observe(priceEl, { childList: true, characterData: true, subtree: true });
    priceObserver.observe(addBtn, { childList: true, characterData: true, subtree: true, attributes: true });
    syncSticky();
  }

  /* ══════════════════════════════════════════
     MÓDULO: RELATED COLOR SYNC
  ══════════════════════════════════════════ */
  function initRelatedColorSync() {
    const colorBtns   = $$('.pdp-color-swatch');
    const relCards    = $$('[data-product-colors]');
    const emptyState  = document.getElementById('pdp-related-empty');
    const relatedGrid = document.getElementById('pdp-related-grid');
    if (!colorBtns.length || !relCards.length) return;

    colorBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const selectedColor = btn.dataset.value;
        let visibleCount = 0;

        relCards.forEach(card => {
          let colors = {};
          try { colors = JSON.parse(card.dataset.productColors || '{}'); } catch { colors = {}; }

          const imgEl = card.querySelector('.pc-related-img');
          const colorKeys = Object.keys(colors);
          const matchKey  = colorKeys.find(k => k.toLowerCase() === selectedColor.toLowerCase());

          // R1.2: sin mapa de colores utilizable no hay con qué filtrar (hoy el
          // Liquid entrega '{}' cuando ninguna variante tiene featured_image).
          // La tarjeta se queda visible y su imagen no se toca; antes se ocultaban
          // todas y la sección de relacionados desaparecía.
          if (!colorKeys.length) {
            card.style.display = '';
            visibleCount++;
            return;
          }

          if (matchKey) {
            card.style.display = '';
            visibleCount++;
            if (imgEl && colors[matchKey]) imgEl.src = colors[matchKey];
          } else {
            card.style.display = 'none';
          }
        });

        if (emptyState) emptyState.style.display = visibleCount === 0 ? '' : 'none';
        if (relatedGrid) relatedGrid.style.display = visibleCount === 0 ? 'none' : '';
      });
    });
  }

  /* ══════════════════════════════════════════
     MÓDULO: INCLUYE CAROUSEL DOTS
  ══════════════════════════════════════════ */
  function initIncluyeCarousel() {
    const track = document.getElementById('pdp-incluye-track');
    const dotsEl = document.getElementById('pdp-incluye-dots');
    if (!track || !dotsEl) return;

    const cards = Array.from(track.querySelectorAll('.pdp-incluye2-card'));
    if (cards.length <= 1) return;

    // Crear dots
    cards.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'pdp-incluye2-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Ir a elemento ' + (i + 1));
      dot.addEventListener('click', () => {
        cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
      dotsEl.appendChild(dot);
    });

    const dots = Array.from(dotsEl.querySelectorAll('.pdp-incluye2-dot'));

    // Actualizar dot activo en scroll
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          const idx = cards.indexOf(entry.target);
          dots.forEach((d, i) => d.classList.toggle('active', i === idx));
        }
      });
    }, { root: track, threshold: 0.5 });

    cards.forEach(c => io.observe(c));
  }

  /* ══════════════════════════════════════════
     MÓDULO: NAV SCROLL (sombra header)
  ══════════════════════════════════════════ */
  function initNavScroll() {
    const nav = document.getElementById('main-nav');
    if (!nav) return;
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ══════════════════════════════════════════
     INIT
  ══════════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', () => {
    [
      ['Carousel',          () => Carousel.init()],
      ['Variants',          () => Variants.init()],
      ['Tabs',              () => Tabs.init()],
      ['FaqDrawer',         () => initFaqDrawer()],
      ['TradeinVideoLightbox', () => initTradeinVideoLightbox()],
      ['StickyCta',         () => initStickyCta()],
      ['RelatedColorSync',  () => initRelatedColorSync()],
      ['IncluyeCarousel',   () => initIncluyeCarousel()],
      ['Reviews',           () => Reviews.init()],
      ['ReviewForm',        () => ReviewForm.init()],
      ['NavScroll',         () => initNavScroll()],
    ].forEach(([name, fn]) => {
      try { fn(); } catch (e) { console.error('[PDP] ' + name + ' init error:', e); }
    });
  });

})();